import { Controller } from 'react-hook-form';
import useCoursesReportsFilters from '../../hooks/useCoursesReportFilters';
import { CoursesReportsFiltersContainer } from './CoursesReportsFilters.styled';
import { Search } from '@mui/icons-material';
import SearchTextField from 'Components/SeachTextField/SearchTextField';
import useTranslation from 'Hooks/useTranslation';
import CustomSelect from 'Components/CustomSelect/CustomSelect';
import { CourseReportFilterI } from 'types';
import {
  ResetButton,
  SearchButton,
} from 'Pages/reports/[submodules]/employees/components/EmployeesReportFilters/EmployeesReportFilters.styled';

interface Props {
  onSearch?: (filters: CourseReportFilterI) => void;
}

const CoursesReportFilters = ({ onSearch }: Props) => {
  const { t2 } = useTranslation('courses_reports');
  const { control, prioritiesData, onResetFilters, getValues, isDirty } = useCoursesReportsFilters({ onSearch });

  return (
    <CoursesReportsFiltersContainer>
      <Controller
        name="name"
        control={control}
        render={({ field }) => <SearchTextField placeholder={t2('search_placeholder')} {...field} />}
      />

      <Controller
        name="prioritiesId"
        control={control}
        render={({ field }) => (
          <CustomSelect
            placeholder={t2('priority_placeholder')}
            options={prioritiesData?.map(priority => ({
              value: priority.id,
              label: priority.name,
            }))}
            {...field}
          />
        )}
      />

      <SearchButton
        variant="outlined"
        color="success"
        hidden={!isDirty}
        startIcon={<Search />}
        onClick={() => {
          const values = getValues();
          onSearch(values);
        }}
      >
        {t2('search')}
      </SearchButton>

      {isDirty && (
        <ResetButton onClick={onResetFilters} variant="outlined">
          {t2('reset')}
        </ResetButton>
      )}
    </CoursesReportsFiltersContainer>
  );
};

export default CoursesReportFilters;
